// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { NamedExoticComponent } from "react";

export const constants = {
    footer: {
        offsetTop: 16,
        offsetTopmd: 48,
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 346,
            height: 230,
        },
        mobile: {
            width: 328,
            height: 280,
        },
    },
    onePageCheckout: {
        tablet: 1242,
    },
};

export const XNGAGE_CUSTOM_WIDGET = "Xngage Custom" as any;
export const EMPTY_VALUE = "---";
export const DivWrapper = `div[class^="Wrapper"]`;

export const MY_ACCOUNT_LIST_PAGES = [
    "OrderHistoryPage",
    "VmiOrderHistoryPage",
    "OrderHistoryRealTimePage",
    "SavedOrderListPage",
    "OrderApprovalListPage",
    "InvoiceHistoryPage",
    "MyListsPage",
    "RfqMyQuotesPage",
];

interface AddToCartStatusInfoInterface {
    status: string;
    label: string;
    icon: NamedExoticComponent<{}> | string;
}
interface AddToCartStatusInterface {
    default: AddToCartStatusInfoInterface;
    loading: AddToCartStatusInfoInterface;
    success: AddToCartStatusInfoInterface;
}

export const addToCartStatus: AddToCartStatusInterface = {
    default: {
        status: "default",
        label: "Add to Cart",
        icon: "",
    },
    loading: {
        status: "loading",
        label: "",
        icon: "",
    },
    success: {
        status: "success",
        label: "Added",
        icon: "",
    },
};

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
};

export const checkoutPages = ["OnePageCheckoutPage", "CheckoutShippingPage", "CheckoutReviewAndSubmitPage"];

export const sharedDateTimeOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export enum USER_ROLES {
    ADMIN = "Administrator",
    BUYER1 = "Buyer1",
    BUYER2 = "Buyer2",
    BUYER3 = "Buyer3",
    FINANCE = "Finance",
    REQUISITIONER = "Requisitioner",
    WHOLESALER_ADMIN = "Wholesaler_Admin",
    RETAILER = "Retailer",
    SYNDICATE_ADMIN = "Syndicate_Admin",
}

export const placeHolders = {
    email: "eg. example@gmail.com",
    phone: "( ___ ) ___ - ____",
};

export const PRODUCT_CAROUSEL_SLIDES_PER_SCREEN_SIZE = {
    miniCardView: {
        mobile: 1,
        tablet: 2,
        desktop: 4,
        wide: 4,
    },
    gridView: {
        mobile: 1,
        tablet: 3,
        desktop: 6,
        wide: 6,
    },
};

export const productOptionsTablePageSize = 8;

export const TRANSACTION_TIMEOUT_COOKIE_NAME = "TRANSACTION_TIMEOUT";

export const HEADER_HEIGHT_CSS_VAR = "--headerHeight";
export const PAGE_LAYOUT_SPACING = {
    lg: "--PageLayoutSpacingLg",
    xl: "--PageLayoutSpacingXl",
};
export const clientWidth = `calc(100vw - (100vw - 100%))`;

export const RICH_TEXT_FIELD_EXT_CONFIGS = {
    lineHeights: {
        Default: "",
        Single: "1",
        "1.15": "1.15",
        "1.5": "1.5",
        Double: "2",
        "11px": "11px",
        "15px": "15px",
        "16px": "16px",
        "17px": "17px",
        "18px": "18px",
        "19px": "19px",
        "20px": "20px",
        "22px": "22px",
        "24px": "24px",
        "26px": "26px",
    },
};
